import { Box, Card, Row, Skeleton, Stack } from '@leanin/ui';

type Variant = 'listRow' | 'card';

export function GroupRowSkeleton({ variant = 'listRow' }: { variant?: Variant }) {
  const body = (
    <Row gap="md" align="center" style={{ minWidth: 0 }}>
      <Skeleton width={44} height={44} rounded="md" style={{ flexShrink: 0 }} />
      <Stack gap="xs" style={{ flex: 1, minWidth: 0 }}>
        <Skeleton width="65%" height={15} rounded="sm" />
        <Row gap="sm" align="center">
          <Skeleton width={52} height={20} rounded="full" />
          <Skeleton width="40%" height={12} rounded="sm" />
        </Row>
      </Stack>
      <Skeleton width={64} height={32} rounded="md" style={{ flexShrink: 0 }} />
    </Row>
  );

  if (variant === 'card') {
    return (
      <Card pad="default">
        {body}
      </Card>
    );
  }

  return (
    <Box p="lg">
      {body}
    </Box>
  );
}
